import { useContext, useDebugValue } from "react";
import AuthContext from "store/auth-context";

export default function useAuth() {
  const authContext = useContext(AuthContext);
  const { auth } = authContext;

  useDebugValue(auth, (auth) => (auth?.user ? "Logged In" : "Logged Out"));
  return authContext;
}
